import { render, staticRenderFns } from "./VendorPayments.vue?vue&type=template&id=2a9c0c5c"
import script from "./VendorPayments.vue?vue&type=script&lang=js"
export * from "./VendorPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a9c0c5c')) {
      api.createRecord('2a9c0c5c', component.options)
    } else {
      api.reload('2a9c0c5c', component.options)
    }
    module.hot.accept("./VendorPayments.vue?vue&type=template&id=2a9c0c5c", function () {
      api.rerender('2a9c0c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Vendors/VendorPayments.vue"
export default component.exports